7
<template>
  <div
    class="modal fade"
    id="level-check-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modal">
            {{ $t("level-check") }}
          </h5>
          <div
            class="ml-auto pointer"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal()"
          >
            <i class="fa-solid fa-xmark fa-xl text-darkdark"></i>
          </div>
          <!-- <button type="button" class="close" @click="closeModal()">
            <span aria-hidden="true" class="zmdi zmdi-close zmdi-hc-2x"></span>
          </button> -->
        </div>
        <div class="modal-body">
          <p>{{ $t("please-complete-the-level-check-first") }}</p>
        </div>
        <div class="modal-footer">
          <button
            @click="goLevelCheck()"
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
            id="level-check-modal-btn"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const props = defineProps({
  title: String,
  content: String,
});
const $goPage = inject("$goPage");
const goLevelCheck = () => {
  closeModal();
  $goPage("/msu/level-check");
};
const closeModal = () => {
  $(`#level-check-modal`).modal("hide");
};
</script>
<style lang="scss">
.confirm-title {
  min-height: 52px;
  height: 52px;
}
.title-height {
  min-height: 52px;
  height: 52px;
}
</style>
